import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import {BeatLoader} from "react-spinners";
import loadingGif from "../../assets/img/loading.gif";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import SubventionFilter from '../../filters/SubventionFilter.jsx';
import CategoryFilter from '../../filters/SalesReportEmiCategoryFilter.jsx';
import BrandFilter from '../../filters/SalesReportEmiBrandFilter.jsx';
import ModelFilter from '../../filters/SalesReportEmiModelFilter.jsx';
import EMISchemeFilter from '../../filters/SalesReportEmiSchemeFilter.jsx';
import TenureFilter from '../../filters/SalesReportEmiTenureFilter.jsx';
import EMIIssuerFilter from '../../filters/SalesReportEmiIssuerFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

function numDifferentiation(val, amount_type) {
    if(amount_type==='Thousand'){
        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
        if(val>0 && val<1000) val = val.toFixed(1);
    }
    if(amount_type==='Lakhs'){
        if(val >= 100000) val = (val/100000).toFixed(2) + ' L';
        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
        if(val>0 && val<1000) val = val.toFixed(1);
    }
    return val;
}

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_config = date_range_config('0', '0', '2020-02-01','0');
var DailyEmiSalesReports ='';

var lastTenDays = [];
var lastTenDaysCount = [];
for (var i = 0; i <= 9; i++) {
    var date = new Date(Date.now() -i*24*60*60*1000);
    var dateFormat = moment(date).format('YYYY-MM-DD')+'_Total Transaction Amount';
    var dateFormat1 = moment(date).format('YYYY-MM-DD')+'_Total Cashback  Amount';
    lastTenDays.push(dateFormat);
    lastTenDays.push(dateFormat1);

    var dateFormatCount = moment(date).format('YYYY-MM-DD')+'_Total Transaction Count';
    var dateFormat1Count = moment(date).format('YYYY-MM-DD')+'_Total Cashback Count';
    lastTenDaysCount.push(dateFormatCount);
    lastTenDaysCount.push(dateFormat1Count);
}
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class DailySalesReportEmi extends Component{
    constructor(props) {
        super(props);
        this.state ={
//             dateTo:tod,
//             dateToShow:todShow,
//             todSend:todSend,
//             yestSend:yestSend,
//             datefrom:yest,
//             datefromShow:yestShow,
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            metric: 'volume',
            loadingtable: true,
            is_record: true,
            is_export: false,
            model_visible : false,
            file_url: '',
            rfile: '',
            is_export2: false,
            categoryLists:[],
            categoryValue:'',
            categoryIDs:'',
            brandLists:[],
            brandValue:'',
            brandIDs:'',
            modelLists:[],
            modelValue:'',
            modelIDs:'',
            tenureLists:[],
            tenureValue:'',
            tenureIDs:'',
            subventionLists:[],
            subventionValue:'',
            subventionIDs:'',
            emiIssuerLists:[],
            emiIssuerValue:'',
            emiIssuerIDs:'',
            emiSchemeLists:[],
            emiSchemeValue:'',
            emiSchemeIDs:'',
            store_level_chain_code:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            columns:[],
            groupColumns:[],
            store_columns:[],
            store_groupColumns:[],
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            tableBody1: [],
            tableHeaders1: [],
            isChange: false,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            amount_type: 'Thousand',
            fetch_data:false
        }
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentDidUpdate() {
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "ubc_txn_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }


        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        }
    componentDidMount() {
        $("#DailyEmiSalesReports").hide();
        $("#DailyEmiSalesReportsStore").hide();

        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getAllMerchants();
        this._get_acq_banks();
        //this._get_issuing_banks();
//         this._get_city();
        this._getCategory();
        this._getBrand();
        this._getModel('');
        this._getTenure();
        this._getEmiIssure();
        this._getEmiScheme();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');

            this.get_filtered_emi_sales_report(decoded.object_type,arrayCode,'');
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                search_object_code: decoded.object_code,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            setTimeout(function(){
                this.get_filtered_emi_sales_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            setTimeout(function(){
                this.get_filtered_emi_sales_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            setTimeout(function(){
                this.get_filtered_emi_sales_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'daily_sales_emi','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("sales_reports")===false || reportPermissions.includes("daily_sales_emi")===false){
            this.unauthorize_access();
        }

    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    get_filtered_emi_sales_report(object_type, object_code, event) {

        $("#DailyEmiSalesReports").hide();
        $("#DailyEmiSalesReports_wrapper").hide();
        $("#DailyEmiSalesReportsStore").hide();
        $("#DailyEmiSalesReportsStore_wrapper").hide();
        var that = this;
        this.setState({
            loadingtable: true,
            is_record: true,
            is_export: false,
            is_export2:false
        });
        let tableHeaders=[];
        let tableHeadersCol=[];
        let tableComplexHeaders=[];
        let tableBody = [];
        let tableHeaders1=[];
        let tableHeadersCol1=[];
        let tableComplexHeaders1=[];
        let tableBody1 = [];
        if(this.state.metric=='volume'){
            if(Array.isArray(lastTenDays) && lastTenDays.length){
                tableHeaders.push(
                    {
                        sTitle: 'Merchant',
                        mData: 'Merchant',
                        // className: 'details-control',
                        "width": "150px",
                        className: ""
                    },
                    {
                        sTitle: 'Chain',
                        mData: 'Merchant Code',
                        "width": "150px",
                        className: ""
                    });
                tableBody.push({ data: 'Merchant' }, { data: 'Merchant Code' },);
                lastTenDays.forEach(function (k) {
                    var res = k.split("_");
                    if(tableComplexHeaders.includes(res[0])===false) {
                        tableComplexHeaders.push(res[0]);
                    }
                    tableHeadersCol.push(res[1]);
                    tableHeaders.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.'),
                        "width": "70px",
                        className: "text-right"
                    });
                    tableBody.push({
                        data: k,
                        className: "text-right"
                    })
                    console.log(k);
                });
                that.setState({
                    columns:tableHeadersCol,
                    groupColumns:tableComplexHeaders
                })
                // var filtersKkeys1 = keys.filter(e => e !== 'Merchant');
                // var filtersKkeys12 = filtersKkeys.filter(e => e !== 'Merchant Code');
                // var shortedDate1 = filtersKkeys12.sort().reverse();

                tableHeaders1.push(
                    {
                        sTitle: 'Store',
                        mData: 'Store',
                        // className: 'details-control',
                        "width": "150px",
                        className: ""
                    },
                    {
                        sTitle: 'UTID',
                        mData: 'Store Code',
                        "width": "150px",
                        className: ""
                    });
                tableBody1.push({ data: 'Store' }, { data: 'Store Code' },);
                lastTenDays.forEach(function (k) {
                    var res1 = k.split("_");
                    if(tableComplexHeaders1.includes(res1[0])===false) {
                        tableComplexHeaders1.push(res1[0]);
                    }
                    tableHeadersCol1.push(res1[1]);
                    tableHeaders1.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.'),
                        "width": "70px",
                        className: "text-right"
                    });
                    tableBody1.push({
                        data: k,
                        className: "text-right"
                    })
                });
                that.setState({
                    store_columns:tableHeadersCol1,
                    store_groupColumns:tableComplexHeaders1
                })

                this.setState({
                    loadingtable: false,
                    is_record: true,
                    is_export: true
                });
                $("#DailyEmiSalesReports").show();
                $("#DailyEmiSalesReports_wrapper").show();
                setTimeout(function(){
                    this.get_filtered_emi_sales_report_data(object_type, object_code, event, tableHeaders, tableBody,tableHeaders1,tableBody1);
                }.bind(this), 200);

            } else {
                //alert("hi");
                $("#DailyEmiSalesReports").hide();
                $("#DailyEmiSalesReports_wrapper").hide();
                this.setState({
                    is_record: false,
                    loadingtable: false,
                });
            }
        }
        else {
            if(Array.isArray(lastTenDaysCount) && lastTenDaysCount.length){
                tableHeaders.push(
                    {
                        sTitle: 'Merchant',
                        mData: 'Merchant',
                        // className: 'details-control',
                        "width": "150px",
                        className: ""
                    },
                    {
                        sTitle: 'Chain',
                        mData: 'Merchant Code',
                        "width": "150px",
                        className: ""
                    });
                tableBody.push({ data: 'Merchant' }, { data: 'Merchant Code' },);
                lastTenDaysCount.forEach(function (k) {
                    var res = k.split("_");
                    if(tableComplexHeaders.includes(res[0])===false) {
                        tableComplexHeaders.push(res[0]);
                    }
                    tableHeadersCol.push(res[1]);
                    tableHeaders.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.'),
                        "width": "70px",
                        className: "text-right"
                    });
                    tableBody.push({
                        data: k,
                        className: "text-right"
                    })
                    console.log(k);
                });
                that.setState({
                    columns:tableHeadersCol,
                    groupColumns:tableComplexHeaders
                })
                // var filtersKkeys1 = keys.filter(e => e !== 'Merchant');
                // var filtersKkeys12 = filtersKkeys.filter(e => e !== 'Merchant Code');
                // var shortedDate1 = filtersKkeys12.sort().reverse();

                tableHeaders1.push(
                    {
                        sTitle: 'Store',
                        mData: 'Store',
                        // className: 'details-control',
                        "width": "150px",
                        className: ""
                    },
                    {
                        sTitle: 'UTID',
                        mData: 'Store Code',
                        "width": "150px",
                        className: ""
                    });
                tableBody1.push({ data: 'Store' }, { data: 'Store Code' },);
                lastTenDaysCount.forEach(function (k) {
                    var res1 = k.split("_");
                    if(tableComplexHeaders1.includes(res1[0])===false) {
                        tableComplexHeaders1.push(res1[0]);
                    }
                    tableHeadersCol1.push(res1[1]);
                    tableHeaders1.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.'),
                        "width": "70px",
                        className: "text-right"
                    });
                    tableBody1.push({
                        data: k,
                        className: "text-right"
                    })
                });
                that.setState({
                    store_columns:tableHeadersCol1,
                    store_groupColumns:tableComplexHeaders1
                })

                this.setState({
                    loadingtable: false,
                    is_record: true,
                    is_export: true
                });
                $("#DailyEmiSalesReports").show();
                $("#DailyEmiSalesReports_wrapper").show();
                setTimeout(function(){
                    this.get_filtered_emi_sales_report_data(object_type, object_code, event, tableHeaders, tableBody,tableHeaders1,tableBody1);
                }.bind(this), 200);

            } else {
                //alert("hi");
                $("#DailyEmiSalesReports").hide();
                $("#DailyEmiSalesReports_wrapper").hide();
                this.setState({
                    is_record: false,
                    loadingtable: false,
                });
            }
        }
    }

    _getEmiScheme(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-scheme-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => { console.log(response);
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((scheme, index) => {
                    this.state.emiSchemeLists.push({value: scheme.scheme, label: scheme.scheme})
                });
            }
        });
    }
    changeEmiScheme(optionSelected) {
        let value = '';
        let schemeArray = [];
        if (optionSelected === null) {
            value = null;
        } else {
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
                var index = this.state.emiSchemeLists.findIndex(obj => obj.value==mids.value);
                this.state.emiSchemeLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(schemeArray, this.state.active_emiSchemeIDs);
        this.setState({
            emiSchemeIDs:schemeArray,
            emiSchemeValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, schemeArray);
    }
    _getEmiIssure(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-issuer-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuer, index) => {
                    this.state.emiIssuerLists.push({value: issuer.issuer, label: issuer.issuer})
                });
            }
        });
    }
    changeEmiIssuer(optionSelected){
        let value='';
        let emiIssuerArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                emiIssuerArray.push(mids.value)
                var index = this.state.emiIssuerLists.findIndex(obj => obj.value==mids.value);
                this.state.emiIssuerLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(emiIssuerArray, this.state.active_emiIssuerIDs);
        this.setState({
            emiIssuerIDs:emiIssuerArray,
            emiIssuerValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, emiIssuerArray, this.state.emiSchemeIDs);
    }
    _getTenure(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-tenure/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((Tenure, index) => {
                    this.state.tenureLists.push({value: Tenure.tenure, label: Tenure.tenure})
                });
            }
        });
    }
    changeTenure(optionSelected){
        let value='';
        let tenureArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                tenureArray.push(mids.value)
                var index = this.state.tenureLists.findIndex(obj => obj.value==mids.value);
                this.state.tenureLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(tenureArray, this.state.active_tenureIDs);
        this.setState({
            tenureIDs:tenureArray,
            tenureValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, tenureArray, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }
    _getCategory(){
        axios.post(config.get('API_URL')+'/reports/sales-emi-category/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((category, index) => {
                    this.state.categoryLists.push({value: category.category, label: category.category})
                });
            }
        });
    }
    changeCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                catArray.push(mids.value)
                var index = this.state.categoryLists.findIndex(obj => obj.value==mids.value);
                this.state.categoryLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(catArray, this.state.active_categoryIDs);
        this.setState({
            categoryIDs:catArray,
            categoryValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, catArray, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }

    _getBrand(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-brand/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((brand, index) => {
                    this.state.brandLists.push({value: brand.brand, label: brand.brand})
                });
            }
        });
    }
    changeBrand(optionSelected){
        let value='';
        let brandArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                brandArray.push(mids.value)
                var index = this.state.brandLists.findIndex(obj => obj.value==mids.value);
                this.state.brandLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(brandArray, this.state.active_brandIDs);
        this.setState({
            brandIDs:brandArray,
            brandValue:optionSelected,
        });
        this.setState({
            modelLists:[],
            modelValue:null,
            modelIDs:'',
            isChange: is_enable
        })
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, brandArray, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
        this._getModel(brandArray);
    }

    _getModel(brandArray){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-model/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
                brandArray: brandArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((model, index) => {
                    this.state.modelLists.push({value: model.model, label: model.model})
                });
            }
        });
    }
    changeModel(optionSelected){
        let value='';
        let modelArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                modelArray.push(mids.value)
                var index = this.state.modelLists.findIndex(obj => obj.value==mids.value);
                this.state.modelLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(modelArray, this.state.active_modelIDs);
        this.setState({
            modelIDs:modelArray,
            modelValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, modelArray, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }


    get_filtered_emi_sales_report_data( object_type, object_code, event, tableHeaders, tableBody,tableHeaders1,tableBody1) {
        var that = this;
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
            this.setState({
                merchantID:object_code
            })
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
            this.setState({
                chainID:object_code
            })
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
            this.setState({
                storeID:object_code
            })
        }
        disabledBody();
        this.setState({
            tableBody1: tableBody1,
            tableHeaders1: tableHeaders1
        })
        //console.log(mids); console.log(cids); console.log(sids); console.log(bids); console.log(cityids); console.log(fr);
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            sale_type: 'EMI',
            categoryIDs: this.state.categoryIDs,
            brand: this.state.brandIDs,
            model: this.state.modelIDs,
            tenure: this.state.tenureIDs,
            subvention: this.state.subventionIDs,
            emiIssuer:  this.state.emiIssuerIDs,
            emiScheme: this.state.emiSchemeIDs
        };
        if ($.fn.DataTable.isDataTable('#DailyEmiSalesReports')) {
            $('#DailyEmiSalesReports').DataTable().clear().destroy();
        }
        var DailyEmiSalesReportsTable = $('#DailyEmiSalesReports').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/sales-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        enabledBody();
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody();
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },
                //aoColumns:tableHeaders,
                columns: tableBody,
                "columnDefs": [
                    {
                        render: function (data) {
                            return '<td ><div class="collapseFirstTD"><a href="#">'+data+'</a> </div></td>';
                        },
                        className: "summary_plus clickable",
                        targets: 0,
                        aTargets: [ -1 ]
                    },
                    {
                        render: function (data) {
                            return '<td >&nbsp;</td>';
                        },
                        targets: 1,
                        aTargets: [ -1 ]
                    },
                    {  render: function (data) {
                            return '<td >'+numDifferentiation(data,that.state.amount_type)+'</td>';
                        },
                        "targets": [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21]
                    },
                ],
            });

        $('#DailyEmiSalesReports').on('click', 'td.clickable', function(e){
            e.preventDefault();
            var tr = $(this).closest('tr');
            var row = DailyEmiSalesReportsTable.row( tr );
            if ( row.child.isShown() ) {  //alert("hide");
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            }
            else {
                // Open this row
                if(row.data()!=undefined) {
                    disabledBody();
                    var mcode = row.data()["Merchant Code"];
                    var content = '';
                    var chainData1 = {
                        mcode: mcode,
                        cids: chains,
                        sids: stores,
                        bids: that.state.acqBankIds,
                        cityids: that.state.cityIds,
                        from: that.state.yestSend,
                        to: that.state.todSend,
                        metric: that.state.metric,
                        sale_type: 'EMI',
                        categoryIDs: that.state.categoryIDs,
                        brand: that.state.brandIDs,
                        model: that.state.modelIDs,
                        tenure: that.state.tenureIDs,
                        subvention: that.state.subventionIDs,
                        emiIssuer:  that.state.emiIssuerIDs,
                        emiScheme: that.state.emiSchemeIDs
                    }
                    var loadingImg = "<div style='text-align: left'><img src="+loadingGif+"></div>";
                    row.child(loadingImg).show();
                    var ttype = 'EMI';
                    $.ajax({
                        type: 'POST',
                        data: chainData1,
                        url: config.get('API_URL') + "/reports/sales-reports-details",
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            //console.log(data);
                            content = '<table id="innerTable1" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                content = content + '<tr>';
                                tableHeaders.map((val, index) =>  {
                                    var clWidth = val.width;
                                    var ClickableTd = numDifferentiation( value[val.sTitle],that.state.amount_type);
                                    if(val.sTitle=='Chain') {
                                        ClickableTd = '<a href="#" data-chain="'+value["Chain Code"]+'">'+value[val.sTitle]+'</a>';
                                    }
                                    content = content + '<td class="chain_level '+val.className+'"  style="width:' + clWidth + '">' + ClickableTd + ' </td>';
                                });
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content,'no-padding').show();
                            tr.addClass('shown');
                            enabledBody();
                            // var td = $(this).closest('tr');
                        },
                        error: function (data) {
                            alert("Failed to load data. Please try again");
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
        var DailyEmiSalesReportsStoreTable = '';
        var chainCode = '';
        $('#DailyEmiSalesReports').on('click', 'td.chain_level a', function (e) {
            e.stopImmediatePropagation();
            $("#DailyEmiSalesReportsStore").show();
            $("#DailyEmiSalesReportsStore_wrapper").show();
            chainCode = $(this).data("chain");
            disabledBody();
            //alert(tableBody1);
            var postData1 = {
                chain_code: chainCode,
                metric: that.state.metric,
                sale_type: 'EMI',
                sids: that.state.storeID,
                mids:merchants,
                bids: that.state.acqBankIds,
                cityids: that.state.cityIds,
                from: that.state.yestSend,
                to: that.state.todSend,
                categoryIDs: that.state.categoryIDs,
                brand: that.state.brandIDs,
                model: that.state.modelIDs,
                tenure: that.state.tenureIDs,
                subvention: that.state.subventionIDs,
                emiIssuer: that.state.emiIssuerIDs,
                emiScheme: that.state.emiSchemeIDs


            };
            if ($.fn.DataTable.isDataTable('#DailyEmiSalesReportsStore')) {
                $('#DailyEmiSalesReportsStore').DataTable().clear().destroy();
            }
            DailyEmiSalesReportsStoreTable = $('#DailyEmiSalesReportsStore').DataTable(
                {
                    order:[],
                    //"dom": 'fltip',
                    "processing": true,
                    "serverSide": true,
                    "bDestroy": true,
                    "paging": true,
                    "pageLength": 20,
                    "bInfo" : false,
                    "sPaginationType": "numbers",
                    //"autoWidth": false,
                    "responsive": false,
                    "scrollX": true,
                    "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],

                    ajax: {
                        url:config.get('API_URL')+ "/reports/sales-reports-store",
                        type: "POST",
                        data: postData1,
                        dataSrc:function ( json ) {
                            // if (json.data == "" || json.data == null) {
                            //     document.getElementById('DailyEmiSalesReportsStore_paginate').style.display = "none";
                            // }
                            enabledBody();
                            return json.data;
                        },
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        error: function (data) {
                            enabledBody();
                            alert("Failed to load data. Please try again");
                        },
                        complete: function (data) {
                            enabledBody()
                        },
                    },
                    //aoColumns:tableHeaders1,
                    columns: that.state.tableBody1,
                    "columnDefs": [
                        {
                            render: function (data) {
                                return '<td ><div class="collapseFirstTD"><a href="#">'+data+'</a> </div></td>';
                            },
                            className: "summary_plus clickable",
                            targets: 0,
                            aTargets: [ -1 ]
                        },
                        {
                            render: function (data) {
                                return '<td >&nbsp;</td>';
                            },
                            targets: 1,
                            aTargets: [ -1 ]
                        },
                        {  render: function (data) {
                                return '<td >'+numDifferentiation(data,that.state.amount_type)+'</td>';
                            },
                            "targets": [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21]
                        },
                    ],
                });
            $('html, body').animate({
                scrollTop: $("#StoreLabel").offset().top
            }, 1000);
            that.setState({
                is_export2:true,
                store_level_chain_code: chainCode
            })

        });
        $('#DailyEmiSalesReportsStore').on('click', 'td.clickable', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            //alert(chainCode);
            var tr = $(this).closest('tr');
            var row = DailyEmiSalesReportsStoreTable.row( tr );
            if ( row.child.isShown() ) {  //alert("hide");
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            }
            else {
                // Open this row
                if(row.data()!=undefined) {
                    disabledBody();
                    var scode = row.data()["Store Code"];
                    var content = '';
                    var storeData = {
                        ccode: chainCode,
                        metric: that.state.metric,
                        sale_type: 'EMI',
                        scode: scode,
                        sids: stores,
                        mids: merchants,
                        bids: that.state.acqBankIds,
                        cityids: that.state.cityIds,
                        from: that.state.yestSend,
                        to: that.state.todSend,
                        categoryIDs: that.state.categoryIDs,
                        brand: that.state.brandIDs,
                        model: that.state.modelIDs,
                        tenure: that.state.tenureIDs,
                        subvention: that.state.subventionIDs,
                        emiIssuer: that.state.emiIssuerIDs,
                        emiScheme: that.state.emiSchemeIDs

                    }
                    //console.log(storeData)
                    var loadingImg = "<div style='text-align: left'><img src="+loadingGif+"></div>";
                    row.child(loadingImg).show();
                    $.ajax({
                        type: 'POST',
                        data: storeData,
                        url: config.get('API_URL') + "/reports/sales-reports-store-details",
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            // console.log(data);
                            content = '<table id="innerTable1" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                content = content + '<tr>';
                                that.state.tableHeaders1.map((val, index) => {
                                    //alert(val.sTitle);
                                    var clWidth = val.width;
                                    var ClickableTd = numDifferentiation(value[val.sTitle],that.state.amount_type);
                                    if(val.sTitle=='UTID') {
                                        ClickableTd = value[val.sTitle];
                                    }
                                    content = content + '<td class="chain_level '+val.className+'"  style="width:' + clWidth + '">' + ClickableTd + ' </td>';
                                });
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content,'no-padding').show();
                            tr.addClass('shown');
                            enabledBody();
                            // var td = $(this).closest('tr');
                        },
                        error: function (data) {
                            alert("Failed to load data. Please try again");
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            isChange: is_enable,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,
        });
        // this.get_filtered_emi_sales_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }

    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs);
        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }


    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }
    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        var is_enable = compareValues(acqBankArray, this.state.active_bids);
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }
//     _get_city(){
//         axios.get(config.get('API_URL')+'/reports/get-city/',{
//             headers: {
//                 Authorization: ` ${localStorage.usertoken}`
//             },
//         }).then(response => {
//             if(Array.isArray(response.data) && response.data.length) {
//                 response.data.map((city, index) => {
//                     this.state.cityLists.push({value: city.city_name, label: city.city_name})
//                 });
//             }
//         });
//         this.setState({
//             loading:false
//         })
//     }
//     changeCity(optionSelected){ //console.log(optionSelected);
//         let value='';
//         let cityArray = [];
//         if(optionSelected===null){
//             value = null;
//         }
//         else{
//             optionSelected.map((mids, i) => {
//                 cityArray.push(mids.value)
//                 var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
//                 this.state.cityLists.move(index,0).join(',');
//             });
//         }
//         var is_enable = compareValues(cityArray, this.state.active_cityids);
//         this.setState({
//             cityIds:cityArray,
//             cityValue:optionSelected,
//             isChange: is_enable,
//         });
//         // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray,
//         //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs)
//     }
    _get_issuing_banks(){
        axios.get(config.get('API_URL')+'/invoice/all_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.issuing_bank_id, label: issuBank.issuing_bank_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs)
        }
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.refs.categoryFilter._getCategory(yestSend, todSend);
        this.refs.brandFilter._getBrand(yestSend, todSend);
        this.refs.modelFilter._getModel(this.state.brandIDs,yestSend, todSend);
        this.refs.tenureFilter._getTenure(yestSend, todSend);
        this.refs.eMISchemeFilter._getEmiScheme(yestSend, todSend);
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
//         this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.object_code,false,'');
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleSubvention = (optionSelected,subventionIDs) =>{
        this.setState({
            subventionValue: optionSelected ,
            isChange: true,
            subventionIDs:subventionIDs,
        })
    }
    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleCategory = (optionSelected, categoryIDs) =>
    {
        this.setState({
            categoryIDs:categoryIDs,
            categoryValue: optionSelected,
            isChange: true
        });
    }
    handleBrand = (optionSelected, brandIDs) =>
    {
        this.setState({
            brandIDs:brandIDs,
            brandValue:optionSelected,
            isChange: true
        });
        this.refs.modelFilter._getModel(brandIDs,this.state.yestSend,this.state.todSend);
    }
    handleModel = (optionSelected, modelIDs) =>
    {
        this.setState({
            modelIDs:modelIDs,
            modelValue:optionSelected,
            isChange: true
        });
    }
    handleEMIScheme = (optionSelected, emiSchemeIDs) =>
    {
        this.setState({
            emiSchemeIDs:emiSchemeIDs,
            emiSchemeValue:optionSelected,
            isChange: true
        });
    }
    handleTenure = (optionSelected, tenureIDs) =>
    {
        this.setState({
            tenureIDs:tenureIDs,
            tenureValue:optionSelected,
            isChange: true
        });
    }
    handleEmiIssuer = (optionSelected, emiIssuerIDs) =>
    {
        this.setState({
            emiIssuerIDs:emiIssuerIDs,
            emiIssuerValue:optionSelected,
            isChange: true
        });
    }
    changeMetric(metric, e) {
        var is_enable = compareValues(metric, this.state.active_metric);
        this.setState({
            metric:metric,
            isChange: is_enable
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs)
    }


    downloadEmiSalesCheck(){

    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.categoryIDs ==='' && this.state.cityIds ==='' && this.state.brandIDs ==='' && this.state.modelIDs ==='' && this.state.tenureIDs ==='' && this.state.emiIssuerIDs ==='' && this.state.emiSchemeIDs ==='' && this.state.subventionIDs ===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.downloadEmiSales();
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
        this.downloadEmiSales()
        }
    }
    downloadEmiSales(type, dw_chain_code, e){
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            download: true,
            type: type,
            sale_type: 'EMI',
            categoryIDs: this.state.categoryIDs,
            brand: this.state.brandIDs,
            model: this.state.modelIDs,
            tenure: this.state.tenureIDs,
            subvention: this.state.subventionIDs,
            emiIssuer:  this.state.emiIssuerIDs,
            emiScheme: this.state.emiSchemeIDs,
            dw_chain_code: dw_chain_code,
            category: 'EMI'
        };

        let xhrBank = $.ajax({
            url: config.get('API_URL') + "/reports/all-sales-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyDailySalesEmiFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    copyDailySalesEmiFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'daily_sales_report_emi.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
//             this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
//              this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
//         if(this.state.object_type==='Store')
//         {
//             this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
//         }
        this.refs.subventionFilter.resetSubventionFilter();
        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.categoryFilter._getCategory(date_config.start_date_value, date_config.end_date_value);
        this.refs.eMISchemeFilter.resetEMISchemeFilter();
        this.refs.tenureFilter.resetTenureFilter();
        this.refs.eMIIssuerFilter.resetEMIIssuerFilter();
        this.refs.brandFilter._getBrand(date_config.start_date_value, date_config.end_date_value);
        this.refs.modelFilter._getModel(date_config.start_date_value, date_config.end_date_value);
        this.setState({
//             dateTo:tod,
//             dateToShow:todShow,
//             todSend:todSend,
//             yestSend:yestSend,
//             datefrom:yest,
//             datefromShow:yestShow,
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            subventionValue:[],
            subventionIDs:'',
            categoryValue:[],
            categoryIDs:'',
            brandValue:[],
            brandIDs:'',
            modelValue:[],
            modelIDs:'',
            emiSchemeValue:[],
            emiSchemeIDs:'',
            tenureValue:[],
            tenureIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            storeValue:[],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],

            ciutidValue: [],
            ciutidIds: '',

            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            amount_type:'Thousand'
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    changeAmtType(amt, e) {
        this.setState({
            amount_type:amt,
            isChange: true
        });

    }
    render() {
        // console.log("sfdsssssssssssss");
        // console.log(this.state.groupColumns);
        // console.log(this.state.columns);
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        let a1 = this.state.groupColumns.map((data, index) => {
            return (
                <th colSpan="2" className="centerAlign">{data}</th>
            )
        })

        let b1 = this.state.columns.map((data1, index) => {
            return (
                <th width="70px" >{data1}</th>
            )
        })
        let c1 = this.state.store_groupColumns.map((sdata, index) => {
            return (
                <th colSpan="2" className="centerAlign">{sdata}</th>
            )
        })

        let c2 = this.state.store_columns.map((sdata1, index) => {
            return (
                <th width="70px" >{sdata1}</th>
            )
        })
        // console.log(a1);
        // console.log(b1);

        var vcls = "btn btn-sm btn-default switchMetric";
        var ccls = "btn btn-sm btn-default switchMetric";
        if(this.state.metric=='volume' ) {
            vcls = "btn btn-sm btn-primary switchMetric";
            ccls = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.metric=='count' ) {
            vcls = "btn btn-sm btn-default switchMetric";
            ccls = "btn btn-sm btn-primary switchMetric";
        }
        var vcls1 = "btn btn-sm btn-default switchMetric";
        var ccls1 = "btn btn-sm btn-default switchMetric";
        if(this.state.amount_type=='Thousand' ) {
            vcls1 = "btn btn-sm btn-primary switchMetric";
            ccls1 = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.amount_type=='Lakhs' ) {
            vcls1 = "btn btn-sm btn-default switchMetric";
            ccls1 = "btn btn-sm btn-primary switchMetric";
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        return(
           
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Daily Sales Report (EMI)</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                    {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Acquirer:</label>
                                            <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                            <div className="clearfix"></div>
                                            </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> City: </label>
                                        <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                         <div className="clearfix"></div>
                                    </div>

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Category </label>
                                        <CategoryFilter  ref="categoryFilter" onSelectCategory = {this.handleCategory} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Brand:</label>
                                        <label>Brand:</label>
                                        <BrandFilter ref="brandFilter" onSelectBrand = {this.handleBrand} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Model: </label>
                                        <ModelFilter ref="modelFilter" onSelectmodel = {this.handleModel} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Tenure: </label>
                                        <TenureFilter ref="tenureFilter" onSelectTenure = {this.handleTenure} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Subvention </label>
                                        <SubventionFilter  ref="subventionFilter" onSelectSubvention = {this.handleSubvention} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Issuer: </label>
                                        <EMIIssuerFilter ref="eMIIssuerFilter" onSelectEMIIssuer = {this.handleEmiIssuer} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Scheme: </label>
                                        <EMISchemeFilter ref="eMISchemeFilter" onSelectEMIScheme = {this.handleEMIScheme} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div>
                                                <label>Metric</label>
                                                <div className="alignedCenter">
                                                    <div className="btn-group">
                                                        <button className={vcls} type="button" value="volume" onClick={this.changeMetric.bind(this,'volume')}>volume </button>
                                                        <button className={ccls} type="button" value="count" onClick={this.changeMetric.bind(this,'count')}>count </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop:'10px'}}>
                                                <label>Amount Notation</label>
                                                <div className="alignedCenter">
                                                    <div className="btn-group">
                                                        <button className={vcls1} type="button" value="Thousand" onClick={this.changeAmtType.bind(this,'Thousand')}>Thousand </button>
                                                        <button className={ccls1} type="button" value="Lakhs" onClick={this.changeAmtType.bind(this,'Lakhs')}>Lakhs </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_emi_sales_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_export ?
                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.downloadEmiSalesCheck.bind(this, 'merchant', '')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>: null }

                                    <div className="clearfix"></div>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loadingtable}
                                    />
                                    {this.state.is_record ?
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                            <table id="DailyEmiSalesReports" className="table table-striped table-hover">
                                                <thead>
                                                <tr>
                                                    <th rowSpan="2" className="width-150">Merchant</th>
                                                    <th rowSpan="2"className="width-150">Chain</th>
                                                    {a1}

                                                </tr>
                                                <tr>
                                                    {b1}
                                                </tr>
                                                </thead>
                                                <tbody>

                                                </tbody>
                                            </table>
                                        </div>:
                                        <div className="empty_data"> No record Found</div>
                                    }

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {/*{this.state.is_export2 ?*/}
                                    {/*    <div className="">*/}
                                    {/*        <a href="#" className="exportButton" role="button" onClick={this.downloadEmiSales.bind(this, 'store', this.state.store_level_chain_code)}>*/}
                                    {/*            <i className="fa fa-download" aria-hidden="true"></i>*/}
                                    {/*            Export to CSV*/}
                                    {/*        </a>*/}
                                    {/*    </div>: null }*/}
                                    <div id="StoreLabel" className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="DailyEmiSalesReportsStore" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th rowSpan="2" width="150px">Store</th>
                                                <th rowSpan="2" width="150px">UTID</th>
                                                {c1}

                                            </tr>
                                            <tr>
                                                {c2}
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
         );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(DailySalesReportEmi)